import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const CategoryForm = ({ category }) => {
    const { flash } = usePage().props
    const [saving, setSaving] = useState(false)
    const isEdit = Boolean(category)

    const form = useForm({
        name: category?.name || '',
        sort_order: category?.sort_order ?? 0,
    })

    const fieldError = (key) => {
        const e = form.errors[key]
        return Array.isArray(e) ? e[0] : e
    }

    const path = isEdit
        ? `/admin/sia/manage/formatos-adicionales/categorias/${category.id}/edit`
        : '/admin/sia/manage/formatos-adicionales/categorias/create'

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = {
            preserveScroll: true,
            onFinish: () => setSaving(false),
        }

        if (isEdit) {
            Inertia.post(
                route('sia.manage.formatos.categorias.update', category.id),
                {
                    _method: 'put',
                    name: form.data.name,
                    sort_order: Number(form.data.sort_order),
                },
                opts,
            )
            return
        }

        form.post(route('sia.manage.formatos.categorias.store'), opts)
    }

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath={path} />
            </div>

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">{isEdit ? 'Editar categoría' : 'Nueva categoría'}</h1>
                <Link href={route('sia.manage.formatos.categorias.index')} className="btn btn-sm btn-light">
                    ← Volver al listado
                </Link>
            </div>

            {flash.success && <div className="alert alert-success mb-5">{flash.success}</div>}

            <Card className="card-flush shadow-sm">
                <Card.Body className="py-8 px-6 px-lg-10">
                    <Form onSubmit={submit}>
                        <Row className="g-4 mb-4">
                            <Col md={8}>
                                <Form.Label className="fw-bold">Nombre</Form.Label>
                                <Form.Control
                                    value={form.data.name}
                                    onChange={(e) => form.setData('name', e.target.value)}
                                    className={fieldError('name') ? 'is-invalid' : ''}
                                />
                                {fieldError('name') && <div className="invalid-feedback d-block">{fieldError('name')}</div>}
                            </Col>
                            <Col md={4}>
                                <Form.Label className="fw-bold">Orden</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={form.data.sort_order}
                                    onChange={(e) => form.setData('sort_order', parseInt(e.target.value, 10) || 0)}
                                    className={fieldError('sort_order') ? 'is-invalid' : ''}
                                />
                                {fieldError('sort_order') && <div className="invalid-feedback d-block">{fieldError('sort_order')}</div>}
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={saving || form.processing}>
                            {isEdit ? 'Guardar cambios' : 'Crear categoría'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}

CategoryForm.layout = (page) => <Layout title={page.props.category?.id ? 'Editar categoría' : 'Nueva categoría'}>{page}</Layout>

export default CategoryForm
